module.exports = __webpack_public_path__ + "img/tishi.019164ba.png";